import React from 'react';
import { IconContainer } from './IconContainer';

const IssuesIcon = (props) => {
    return (
        <IconContainer ariaLabel="issues" {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M17.3845 6.5873C19.0661 8.27337 20.7391 9.9508 22.19 11.3978C22.527 11.7305 22.527 12.2696 22.19 12.6022C18.0366 16.741 18.6193 16.1693 19.2619 15.5388C20.0905 14.7259 21.0187 13.8152 12.0195 22.7812C7.30511 18.0826 6.65881 17.439 5.51988 16.3048C4.82033 15.6082 3.93493 14.7265 1.80686 12.6064C1.47409 12.2696 1.47409 11.7305 1.80686 11.3978C1.80686 11.3978 5.04962 8.16339 12.0195 1.21881C13.6208 2.81354 15.5081 4.7058 17.3845 6.5873ZM8.81885 12L12.0195 15.1881L15.2202 12L12.0195 8.81195L8.81885 12Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { IssuesIcon };